import { pentagonPeaks } from '../constants';
import { normalizeCoordinate } from '../helpers';

const PentagonSummitLabels = () => (
  <g
    name="summitLabels"
    className="summit-label"
  >
    <text
      x={`${50 + normalizeCoordinate(pentagonPeaks[0][0])}%`}
      y={`${50 + normalizeCoordinate(pentagonPeaks[0][1]) * 1.05}%`}
      textAnchor="middle"
    >
      H2 %
    </text>
    <text
      x={`${50 + normalizeCoordinate(pentagonPeaks[1][0]) * 1.05}%`}
      y={`${50 + normalizeCoordinate(pentagonPeaks[1][1])}%`}
    >
      C2H2 %
    </text>
    <text
      x={`${50 + normalizeCoordinate(pentagonPeaks[2][0]) * 1.05}%`}
      y={`${50 + normalizeCoordinate(pentagonPeaks[2][1])}%`}
    >
      C2H4 %
    </text>
    <text
      x={`${50 + normalizeCoordinate(pentagonPeaks[3][0]) * 1.05}%`}
      y={`${50 + normalizeCoordinate(pentagonPeaks[3][1])}%`}
      textAnchor="end"
    >
      CH4 %
    </text>
    <text
      x={`${50 + normalizeCoordinate(pentagonPeaks[4][0]) * 1.05}%`}
      y={`${50 + normalizeCoordinate(pentagonPeaks[4][1])}%`}
      textAnchor="end"
    >
      C2H6 %
    </text>
  </g>
);

export default PentagonSummitLabels;
